module.exports = __webpack_public_path__ + "img/1440.a4d19772.jpg";